var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.4 19.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#337ab7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.102 0a1.3 1.3 0 0 1 1.3 1.3v13.922a1.3 1.3 0 0 1-1.3 1.3h-2.697c.014-.136.022-.274.022-.413 0-2.097-1.658-3.796-3.702-3.796-2.045 0-3.702 1.7-3.702 3.796 0 .14.007.277.022.412h-7.14a4 4 0 0 0 .022-.412c0-2.097-1.658-3.796-3.702-3.796-2.045 0-3.702 1.7-3.702 3.796 0 .14.007.277.022.412H1.417A1.3 1.3 0 0 1 .12 15.306c-.185-2.897-.156-4.97.087-6.218.248-1.27.92-2.729 2.02-4.377a1.3 1.3 0 0 1 1.08-.58h6.566V1.3a1.3 1.3 0 0 1 1.3-1.3h15.929ZM8.425 5.37h-3.76a2.26 2.26 0 0 0-1.718.792 5.21 5.21 0 0 0-.58.813c-.255.452-.597 1.333-1.028 2.642a.226.226 0 0 0 .154.288l.06.008h7.323V5.821a.451.451 0 0 0-.451-.451Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.249,
    cy: 16.463,
    rx: 2.819,
    ry: 2.891
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.749,
    cy: 16.463,
    rx: 2.819,
    ry: 2.891
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.a7e2fc2d60aef1b4f08ded19b7eafdcd.svg";
export { ForwardRef as ReactComponent };